/**
 * Created by andermurias on 18/7/17.
 */
import React, { Component } from 'react';

import '../../styles/elements/resumeList.css';

class ResumeList extends Component {
    render() {
        return (
            <div className={'resume-list' + (this.props.className ? ' ' + this.props.className : '')}>
                <p className="resume-list__title">{this.props.title}</p>
                <ul className="resume-list__list">
                    {this.props.elements.map((element, i) => {
                        return (<li className="resume-list__element" key={'rlist-'+i}>{element}</li>)
                    })}
                </ul>
            </div>
        )
    }
}

export default ResumeList;



// WEBPACK FOOTER //
// ./src/js/elements/ResumeList.js